import { SET_REFRESH_TOKEN_FAILED } from './actionTypes';

const initialState = {
	refreshTokenFailed: false,
};

export default (state = initialState, { type, payload }) => {
	switch (type) {
		case SET_REFRESH_TOKEN_FAILED:
			return {
				...state,
				refreshTokenFailed: payload,
			};
		default:
			return state;
	}
};
